var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-simplePage-detail"},[_c('a-card',{attrs:{"bordered":false}},[_c('a-button',{on:{"click":_vm.refreshNextPage}},[_vm._v("重载并返回前一个页面")]),_c('a-button',{on:{"click":_vm.back}},[_vm._v("仅返回")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }